import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getLocale, history } from "../helpers";
import { AuthenticateRoute } from "./AuthenticateRoute";
import { getTokenCookie } from "../helpers/auth-header";
import { store } from "../helpers/store";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const loginState = store.getState()?.login || {};
  const user = loginState.user;
  const userToken = getTokenCookie();

  if ((user && user.token) || userToken) {
    return <AuthenticateRoute Component={Component} {...rest} />;
  }

  if (window.RUNTIME_API_HOST) {
    return <Navigate to="*" state={{ from: location }} replace />;
  }

  // persist so the path survives navigation through /stores/home → /stores/login
  sessionStorage.setItem("postLoginRedirect", location.pathname);
  return (
    <Navigate
      to={getLocale(history.location.pathname, true) + "/stores/home"}
      state={{ from: location }}
      replace
    />
  );
};
